<section>
  <h2>Services</h2>
  <div class="services-container">
    @for (service of services; let index = $index; track service.guid) {
      <div
        class="service-card"
        [attr.data-test-id]="'service-' + index"
        [ngClass]="{ 'cursor-pointer': service.guid }"
        (click)="linkAction(service.guid)">
        <div class="left">
          @if (service.image) {
            <div class="img-preview">
              <picture>
                <img
                  [attr.data-test-id]="'image-' + index"
                  [src]="service.image | sanitizeSrc"
                  [alt]="'Service icon'" />
              </picture>
            </div>
          }
        </div>
        <div class="right">
          <h4>{{ service.name }}</h4>
          <span
            [attr.data-test-id]="'status-' + index"
            [ngClass]="service.status | serviceLogicalStatus">
            {{ service.status | uppercase }}
          </span>
          <ume-plain-html
            [html]="service.description"
            [shownLinesLimit]="3"></ume-plain-html>
        </div>
      </div>
    }
  </div>
</section>
